import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { Input } from '../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../shared/http-client';
import { FilterFooter } from '../../elements/filter-footer';
import { Select } from '../../elements/select';
import { SelectVehicle } from '../../elements/select-vehicle';
import { DatePicker } from '../../elements/date-picker';

// construccion del objecto yup de validacion del cuestionario
let obligado = {};
const validacion = Yup.object().shape(obligado);

const initialValues = {
    vehicle: null,
    timestamp_after: '',
    timestamp_before: ''
};



export const DetectedRefuelingsFilter = ({
    item,
    doFilter,
    close,
}: {
    item?: any;
    close: () => void;
    doFilter: (item: any) => void;
}) => {

    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [vehicles, setVehicles] = useState<any[]>([]);

    useEffect(() => {
        if (item) {
            setData(item);
        }
        api('/fleet/vehicles/', 'GET');
    }, [item]);




    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        for (let key in after) {
            if (!after[key]) {
                delete after[key];
            }
        }

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);
        console.log('enviaremos', enviaremos)

        doFilter(enviaremos);
    };

    useEffect(() => {
        if (state.data && state.path.includes('vehicles')) {
            if (Array.isArray(state.data.results)) {
                setVehicles(state.data.results);
            }
        }
        if (state.error) {
            toast.error(state.error.detail);
        }
    }, [state]);

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={data || initialValues}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({
                    values,
                    errors,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">

                        <SelectVehicle
                            key={values.vehicle}
                            name="vehicle"
                            label={t('common.label.vehiculo')}
                            placeholder="Select value"
                            items={vehicles}
                            value={values.vehicle}
                            onChange={(value) => {
                                console.log('selected vehicle', value);
                                setFieldValue('vehicle', value.id);
                            }}
                        />

                        <div className="">
                            <DatePicker
                                name="timestamp_after"
                                type="date"
                                label={t(
                                    'date_time_after'
                                )}
                                value={values.timestamp_after}
                                onChange={(value) => {
                                    setFieldValue(
                                        'timestamp_after',
                                        value.timestamp_after
                                            ? dayjs(
                                                value.timestamp_after
                                            ).format('YYYY-MM-DD')
                                            : null
                                    );
                                }}
                            />
                        </div>
                        <div className="">
                            <DatePicker
                                name="timestamp_before"
                                type="date"
                                label={t(
                                    'date_time_before'
                                )}
                                value={values.timestamp_before}
                                onChange={(value) => {
                                    setFieldValue(
                                        'timestamp_before',
                                        value.timestamp_before
                                            ? dayjs(
                                                value.timestamp_before
                                            ).format('YYYY-MM-DD')
                                            : null
                                    );
                                }}
                            />
                        </div>

                        <FilterFooter
                            item={item}
                            doDelete={() => doFilter({})}
                            doSubmit={handleSubmit}
                            close={close}
                        />
                    </form>
                )}
            </Formik>
        </div>
    );
};